<template>
    <b-row>
        <b-col md="6">
            <b-card>
                <b-form v-on:submit.prevent enctype="multipart/form-data">
                    <b-row>
                        <b-col cols="12" class="text-left mb-1">
                            <b-badge :variant="statusVariant(this.detail.status)">
                                <span v-if="this.detail.status === 0">{{ detail.status_name }}</span>
                                <span v-else-if="this.detail.status === 1">{{ detail.status_name }}</span>
                                <span v-else-if="this.detail.status === 2">{{ detail.status_name }}</span>
                                <span v-else-if="this.detail.status === 3">{{ detail.status_name }}</span>
                                <span v-else-if="this.detail.status === 4">{{ detail.status_name }}</span>
                            </b-badge>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col md="12">
                            <b-row class="mb-1">
                                <b-col md="12">
                                    <label for="title" class="text-primary font-weight-bold">Purchase Details</label>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    Code
                                </b-col>
                                <b-col md="6" class="text-right text-secondary font-weight-bolder">
                                    {{ detail.code }}
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row>
                                <b-col md="6">
                                    Vendor
                                </b-col>
                                <b-col md="6" class="text-right text-secondary font-weight-bolder">
                                    {{ detail.vendor_name }}
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row>
                                <b-col md="6">
                                    Tax
                                </b-col>
                                <b-col md="6" class="text-right text-secondary font-weight-bolder">
                                    {{ formatRupiah(detail.tax) }}
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row>
                                <b-col md="6">
                                    Additional Cost
                                </b-col>
                                <b-col md="6" class="text-right text-secondary font-weight-bolder">
                                    {{ formatRupiah(detail.additional_cost) }}
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row>
                                <b-col md="6">
                                    Total Price
                                </b-col>
                                <b-col md="6" class="text-right text-secondary font-weight-bolder">
                                    {{ formatRupiah(detail.total_price) }}
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
            <b-card>
                <b-form v-on:submit.prevent enctype="multipart/form-data">
                    <b-row>
                        <b-col md="12">
                            <b-row class="mb-1">
                                <b-col md="12">
                                    <label for="title" class="text-primary font-weight-bold">Items Information</label>
                                </b-col>
                            </b-row>
                            <b-row v-for="(item, index) in detail.items" :key="index" class="mb-1">
                                <b-col md="12">
                                    <hr class="mb-2" v-if="index > 0"/>
                                    <img :src="detail.url+item.product_image" alt="item" width="100px" class="float-left mr-1">
                                    <p class="text-primary font-weight-bold mt-50">{{ item.product_name }}</p>
                                    <p>{{ item.qty }} {{ item.unit_name }} x {{ formatRupiah(item.price) }}</p>
                                    <p class="font-weight-bold">Subtotal : <span class="text-success">{{ formatRupiah(item.qty * item.price) }}</span></p>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-card>
                <b-form v-on:submit.prevent enctype="multipart/form-data">
                    <b-row>
                        <b-col md="12" class="mb-1">
                            <label for="title" class="text-primary font-weight-bold">Form Receiving</label>
                        </b-col>
                        <b-col md="12">
                            <b-form-group
                            label="Warehouse"
                            label-for="warehouse"
                            >
                                <v-select
                                id="warehouse"
                                v-model="form.selectedWarehouse"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="text"
                                :options="form.optionsWarehouse"
                                placeholder="Select 1 Warehouse"
                                >
                                    <template #search="{attributes, events}">
                                        <input
                                        class="vs__search"
                                        :required="!form.selectedWarehouse"
                                        v-bind="attributes"
                                        v-on="events"
                                        />
                                    </template>
                                </v-select>
                                <!-- Selected: <strong>{{ form.selectedWarehouse }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group
                            label="Code"
                            label-for="code"
                            >
                            <b-form-input
                                id="code"
                                placeholder="Code"
                                v-model="form.code"
                                required
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group
                            label="Code Reference"
                            label-for="code_ref"
                            >
                            <b-form-input
                                id="code_ref"
                                placeholder="Code Reference"
                                v-model="form.code_ref"
                                required
                            />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <b-form-group
                            :state="errors"
                            label="Attachment"
                            label-for="Attachment"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display1" alt="display1" width="200" height="200" class="mb-1" :hidden="form.file1 ? false : true"> -->
                                <b-form-file
                                v-model="form.file1"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display1').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file1 ? form.file1.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="12" v-if="numberAttachment >= 1 ">
                            <b-form-group
                            :state="errors"
                            label="Attachment 2"
                            label-for="Attachment_2"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display2" alt="display2" width="200" height="200" class="mb-1" :hidden="form.file2 ? false : true"> -->
                                <b-form-file
                                v-model="form.file2"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display2').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file2 ? form.file2.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="12" v-if="numberAttachment >= 2 ">
                            <b-form-group
                            :state="errors"
                            label="Attachment 3"
                            label-for="Attachment_3"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display3" alt="display3" width="200" height="200" class="mb-1" :hidden="form.file3 ? false : true"> -->
                                <b-form-file
                                v-model="form.file3"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display3').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file3 ? form.file3.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="12" v-if="numberAttachment >= 3 ">
                            <b-form-group
                            :state="errors"
                            label="Attachment 4"
                            label-for="Attachment_4"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display4" alt="display4" width="200" height="200" class="mb-1" :hidden="form.file4 ? false : true"> -->
                                <b-form-file
                                v-model="form.file4"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display4').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file4 ? form.file4.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="12" v-if="numberAttachment >= 4 ">
                            <b-form-group
                            :state="errors"
                            label="Attachment 5"
                            label-for="Attachment_5"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display5" alt="display5" width="200" height="200" class="mb-1" :hidden="form.file5 ? false : true"> -->
                                <b-form-file
                                v-model="form.file5"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display5').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file5 ? form.file5.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="numberAttachment < 4" class="mb-1">
                        <b-col md="12" class="mt-1">
                            <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="secondary"
                            class="mr-1"
                            block
                            @click="moreAttachment()"
                            >
                            Add More Attachment
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <!-- submit and reset -->
                        <b-col md="12" class="mt-2">
                            <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            type="submit"
                            variant="primary"
                            class="mr-1"
                            @click="validation()"
                            >
                            Submit
                            </b-button>
                            <!-- <b-button
                            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            type="reset"
                            variant="outline-secondary"
                            >
                            Reset
                            </b-button> -->
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import {
    BDropdownItem, BDropdown, BBadge, BPagination, BFormFile, BImg, BFormSelect, BListGroupItem, BAvatar, BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ImageUploader from 'vue-image-upload-resize'
import { $themeConfig } from "@themeConfig"
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'

export default {
    components: {
        VueGoodTable,
        ToastificationContent,
        vSelect,
        ImageUploader,
        BPagination,
        BBadge,
        BDropdownItem,
        BDropdown,
        ValidationProvider,
        ValidationObserver,
        BFormFile,
        BImg,
        BFormSelect,
        BListGroupItem,
        BAvatar,
        BCard,
        BCardText,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BForm,
        BButton,
        Prism
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            detail: {
                status: null,
                status_name: '',
                code: '',
                vendor_name: '',
                tax: 0,
                additional_cost: 0,
                total_price: 0,
                items: [],
                url: ''
            },
            form: {
                purchase_id: null,
                selectedWarehouse: null,
                optionsWarehouse: [],
                code: '',
                code_ref: '',
                file1: null,
                file2: null,
                file3: null,
                file4: null,
                file5: null
            },
            numberAttachment: 0,
            hasImage: '',
            image: '',
            photo: '',
            errors: '',
            errMessage: ''
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                0 : 'light-warning',
                1 : 'light-info',
                2 : 'light-primary',
                3 : 'light-success',
                4 : 'light-danger'
            }

            return status => statusColor[status]
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    setup() {
        // App Name
        const { baseUrl, apiUrl } = $themeConfig.app;
        return {
            baseUrl,
            apiUrl
        };
    },
    created() {
        this.getRouteParams()
        this.getWarehouse()
    },
    methods: {
        formatRupiah(money) {
            return new Intl.NumberFormat('id-ID',
                { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
            ).format(money);
        },
        getRouteParams() {
            this.form.purchase_id = sessionStorage.getItem('purchaseID')
            this.getPurchase(this.form.purchase_id)
            this.getPurchaseItems(this.form.purchase_id)
        },
        getPurchase(id) {
            this.$http.get('procurement/purchase/'+id)
            .then(response => { 
                // console.log(response.data.data)
                this.detail.status = response.data.data.status
                this.detail.status_name = response.data.data.status_name
                this.detail.code = response.data.data.code
                this.detail.vendor_name = response.data.data.vendor_name
                this.detail.tax = response.data.data.tax
                this.detail.additional_cost = response.data.data.additional_cost
                this.detail.total_price = response.data.data.total_price
            })
        },
        getPurchaseItems(id) {
            this.$http.get('procurement/purchases/'+id+'/items')
            .then(response => { 
                // console.log(response.data.data)
                this.detail.items = response.data.data
                const { baseUrl } = $themeConfig.app
                this.detail.url = baseUrl
                this.detail.url += 'storage/product/'
            })
        },
        getWarehouse() {
            this.$http.get('warehouses')
            .then(response => { 
                // console.log(response.data.data)
                var datas = response.data.data
                var i
                for(i=0; i<datas.length; i++) {
                    var $data = {
                        value: datas[i].id,
                        text: datas[i].name
                    }
                    // console.log($data)
                    this.form.optionsWarehouse.push($data)
                }
                // console.log(this.form.optionsWarehouse)
            })
        },
        moreAttachment() {
            this.numberAttachment += 1
        },
        validation() {
            if(this.form.selectedWarehouse === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Warehouse field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.code === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Code field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.code_ref === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Code Reference field is required',
                        variant: 'warning',
                    },
                })
            } else {
                this.addProcurementReceiving()
            }
        },
        addProcurementReceiving() {
            let formData = new FormData();
            formData.append("purchase_id", this.form.purchase_id)
            formData.append("warehouse_id", this.form.selectedWarehouse.value)
            formData.append("code", this.form.code)
            formData.append("code_ref", this.form.code_ref)
            if(this.form.file1 !== null) {
                formData.append("attachment_1", this.form.file1)
            }
            if(this.form.file2 !== null) {
                formData.append("attachment_2", this.form.file2)
            }
            if(this.form.file3 !== null) {
                formData.append("attachment_3", this.form.file3)
            }
            if(this.form.file4 !== null) {
                formData.append("attachment_4", this.form.file4)
            }
            if(this.form.file5 !== null) {
                formData.append("attachment_5", this.form.file5)
            }
            this.$http
            .post("procurement/receiving/add", formData)
            .then((response) => {
                // console.log(response.data.data)
                sessionStorage.removeItem("purchaseID")
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Success Receiving',
                        variant: 'success',
                    },
                })
                location.href = "/procurement/receiving"
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            });
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<style>
    #purchase div img.img-preview {
        width: 200px;
        padding-right: 10px;
    }
</style>